import { Routes } from '@angular/router';
import { DashboardRootComponent } from '../_pages/dashboard-root/dashboard-root.component';
import { HomeComponent } from '../_pages/home/home.component';
import { HometspComponent } from '../_pages/hometsp/hometsp.component';
import { DndRegistrationDetailsComponent } from '../_pages/dnd-registration-details/dnd-registration-details.component';
import { EntityRegistrationComponent } from '../_pages/entity-registration/entity-registration.component';
import { EntitySummaryComponent } from '../_pages/entity-summary/entity-summary.component';
import { CommonLoginComponent } from '../_pages/common-login/common-login.component';
import { SubscriberLoginComponent } from '../_pages/subscriber-login/subscriber-login.component';
import { PreferenceNcprDetailsComponent } from '../_pages/preference-ncpr-details/preference-ncpr-details.component';
import { LoginActivateService } from '../_services/loginactivate.service';
import { PrefrenceDownloadComponent } from '../_pages/prefrence-download/prefrence-download.component';
import { InviteUsersComponent } from '../_pages/invite-users/invite-users.component';
import { PreferenceSummaryComponent } from '../_pages/preference-summary/preference-summary.component';
import { ImportPreferenceComponent } from '../_pages/import-preference/import-preference.component';
import { BadWordsImportComponent } from '../_pages/bad-words-import/bad-words-import.component';

import { SearchDndPreferenceComponent } from '../_pages/search-dnd-preference/search-dnd-preference.component';

import { ComplaintsDownloadComponent } from '../_pages/complaints-download/complaints-download.component';
import { ComplaintsNcprSummaryComponent } from '../_pages/complaints-ncpr-summary/complaints-ncpr-summary.component';
import { ComplaintsNcprDetailsComponent } from '../_pages/complaints-ncpr-details/complaints-ncpr-details.component';
import { ComplaintsSummaryComponent } from '../_pages/complaints-summary/complaints-summary.component';
import { EntityIdDetailsComponent } from '../_pages/principal-header-summary/entity-id-details/entity-id-details.component';


import { ContentTemplateRegistrationComponent } from '../_pages/content-template-registration/content-template-registration.component';
import { ContentTemplateRegistrationActionComponent } from '../_pages/content-template-registration-action/content-template-registration-action.component';
import { TemplateModificationComponent } from '../_pages/template-modification/template-modification.component';
import { TemplatesByPEComponent } from '../_pages/templates-by-pe/templates-by-pe.component';

import { BulkContentUploadComponent } from '../_pages/bulk-content-upload/bulk-content-upload.component';
import { ContentTemplateBulkUploadSummaryComponent } from '../_pages/content-template-bulk-upload-summary/content-template-bulk-upload-summary.component';


import { ConsentRegComponent } from '../_pages/consent-new-registration/consent-new-registration.component';
import { EntityConsentReportComponent } from '../_pages/entity-consent-template-report/entity-consent-template-report.component';
import { ConsentTemplateBulkUploadSummaryComponent } from '../_pages/consent-template-bulk-upload-summary/consent-template-bulk-upload-summary.component';
import { BulkConsentTemplateRegistrationComponent } from '../_pages/bulk-consent-template-registration/bulk-consent-template-registration.component';


//Header
//import { RootHeaderComponent } from '../_pages/root-header/root-header.component';
import { HeaderVoiceComponent } from '../_pages/header-voice/header-voice.component';
import { HeaderVoiceSummaryComponent } from '../_pages/header-voice-summary/header-voice-summary.component';
//import { RootHeaderSummaryComponent } from '../_pages/root-header-summary/root-header-summary.component';
//import { PrincipalHeaderRegistrationComponent } from '../_pages/principal-header-registration/principal-header-registration.component';
import { PrincipalHeaderSummaryComponent } from '../_pages/principal-header-summary/principal-header-summary.component';
import { HeaderIdDetailsComponent } from '../_pages/header-id-details/header-id-details.component';

import { HeaderModifyComponent } from '../_pages//header-modify/header-modify.component';
import { HeadersByPeComponent } from '../_pages/headers-by-pe/headers-by-pe.component';
import { HeaderRegComponent } from '../_pages/new-header-registration/new-header-registration.component';
import { ImportHeaderComponent } from '../_pages/import-header/import-header.component';
import { HeaderBulkDetailsComponent } from '../_pages/header-bulk-details/header-bulk-details.component';
// Header  audit & edit Log files.
// import { HeaderAuditLogComponent } from '../_pages/header-auditlog/header-auditlog.component';
// import { HeaderEditLogComponent } from '../_pages/header-editlog/header-editlog.component';
import { HeaderSummaryComponent } from '../_pages/header-summary/header-summary.component';

//Consent-Migration
// import { BulkConsentuploadComponent } from '../_pages/bulk-consent-upload/bulk-consent-upload.component';
import { ConsentReportsComponent } from '../_pages/consent-reports/consent-reports.component';
import { ConsentBulkSummaryComponent } from '../_pages/consent-bulk-upload-summary/consent-bulk-upload-summary.component';



//Entity - PhaseI

import { ChangePasswordComponent } from '../_pages/change-password/change-password.component';
import { ForgotPasswordComponent } from '../_pages/forgot-password/forgot-password.component';
import { TMPECommonRegistrationComponent01 } from '../_pages/tmpe-common-registration-01/tmpe-common-registration-01.component';
import { TMPECommonRegistrationComponent02 } from '../_pages/tmpe-common-registration-02/tmpe-common-registration-02.component';
import { TMPEModifyAfterApprovalComponent } from '../_pages/tmpe-modify-after-approval/tmpe-modify-after-approval.component';
import { TMPEModifyBeforeApprovalComponent } from '../_pages/tmpe-modify-before-approval/tmpe-modify-before-approval.component';
import { TmpeCommonLoginComponent } from '../_pages/tmpe-common-login/tmpe-common-login.component';
import { EntityAuditLogComponent } from '../_pages/entity-auditlog/entity-auditlog.component';
import { EntityEditLogComponent } from '../_pages/entity-editlog/entity-editlog.component';
import { EntityReportComponent } from '../_pages/entity-report/entity-report.component';
import { EntityVerificationComponent } from '../_pages/entity-verification/entity-verification.component';
import { EntityWorklistComponent } from '../_pages/entity-worklist/entity-worklist.component';
import { TataCommonLoginComponent } from '../_pages/tata-common-login/tata-common-login.component';
import { TataEntityModificationComponent } from '../_pages/tata-entity-modification/tata-entity-modification.component';
import { TataEntityRegistrationComponent } from '../_pages/tata-entity-registration/tata-entity-registration.component';
import { ModifyRegistrarComponent } from '../_pages/modify-registrar/modify-registrar.component';
import { TtlusersReportComponent } from '../_pages/ttlusers-report/ttlusers-report.component';
import { TtlusersSummaryComponent } from '../_pages/ttlusers-summary/ttlusers-summary.component';
import { TataAuditLogComponent } from '../_pages/tata-auditlog/tata-auditlog.component';

import { ComplaintRegistrationSubscriberComponent } from '../_pages/complaint-registration-subscriber-02/complaint-registration-subscriber-02.component'
import { ComplaintRegistrationSubscriber01Component } from '../_pages/complaint-registration-subscriber-01/complaint-registration-subscriber-01.component'
//observer
import { DashboardComponent } from '../_observer/dashboard/dashboard.component';
import { HeaderObvComponent } from '../_observer/header-obv/header-obv.component';
import { ConsentObvComponent } from '../_observer/consent-obv/consent-obv.component';

import { ComplaintsObvComponent } from '../_observer/complaints-obv/complaints-obv.component';
import { EntityObvComponent } from '../_observer/entity-obv/entity-obv.component';
import { TelemarketerObvComponent } from '../_observer/telemarketer-obv/telemarketer-obv.component';
import { ConsentTemplateObvComponent } from '../_observer/consent-template-obv/consent-template-obv.component';
import { ContentTemplateObvComponent } from '../_observer/content-template-obv/content-template-obv.component';
import { SearchDndPreferenceObvComponent } from '../_observer/search-dnd-preference-obv/search-dnd-preference-obv.component';
import { OperatorWiseCountComponent } from '../_observer/operator-wise-count/operator-wise-count.component';

//Observer - Complaints
import { ComplaintsObvDashboardOapComponent } from '../_observer/complaints-obv-dashboard-oap/complaints-obv-dashboard-oap.component';
import { ComplaintsObvComprehensiveRptComponent } from '../_observer/complaints-obv-comprehensive-rpt/complaints-obv-comprehensive-rpt.component';

import { IpRegistrationComponent } from '../_pages/ip-registration/ip-registration.component';
import { PaymentDuesComponent } from '../_pages/payment-dues/payment-dues.component';
import { PaymentHistoryComponent } from '../_pages/payment-history/payment-history.component';
import { PaymentSubmitComponent } from '../_pages/payment-submit/payment-submit.component';
import { PaymentreceiptComponent } from '../_pages/paymentreceipt/paymentreceipt.component';


import { GstRegistrationComponent } from '../_pages/gst-registration/gst-registration.component'; 
import { GstRegistrationDetailsComponent } from '../_pages/gst-registration-details/gst-registration-details.component';
import { GstregistrationSearchComponent } from '../_pages/gstregistration-search/gstregistration-search.component';
import { LinkingConsentComponent } from '../_pages/linking_consent/linking_consent.component';
import { NonTTLTemplatesComponent } from '../_pages/non-ttl-templates/non-ttl-templates.component';

import { RequestStatusComponent } from '../_pages/request-status/request-status.component';
import { CaptureRequestOnPEComponent } from '../_pages/capture-request-onpe/capture-request-onpe.component';

//consent Acquisition
import { ConsentAcquisitionComponent } from '../_pages/consent-acquisition/consent-acquisition.component';
import { ConsentAcquisitionQRCodeComponent } from '../_pages/consent-acquisition-qrcode/consent-acquisition-qrcode.component';
import { ConsentStatusSummaryComponent } from '../_pages/consent-status-summary/consent-status-summary.component';
import { ConsentAcquisitionScanPgComponent } from '../_pages/consent-acquisition-scanpg/consent-acquisition-scanpg.component';
import { ConsentAcqQrComponent } from '../_pages/consentacqqr/consentacqqr.component';
import { DigitalConsentsummaryComponent } from '../_pages/digital-consentsummary/digital-consentsummary.component';
import { ActivateDigitalConsentComponent } from '../_pages/activate-digital-consent/activate-digital-consent.component';
//BulkTemplateVerificationComponent
import { BulkTemplateVerificationComponent } from '../_pages/bulk-template-verification/bulk-template-verification.component';
import { BulkTemplateVerificationSummaryComponent } from '../_pages/bulk-template-verification-summary/bulk-template-verification-summary.component';



//Entity-Payment

import { AuthGuard } from '../../.././_network/Auth.guard';

//templatecontentmodify
import { TemplatecontentmodifyComponent } from '../_pages/templatecontentmodify/templatecontentmodify.component';

//Header Extension Conversion
import { HeaderSuspensionComponent } from '../_pages/header-suspension/header-suspension.component';
import { ExtensionConversionHeadersComponent } from '../_pages/extension-conversion-headers/extension-conversion-headers.component';


//Voice Headers - TM
import { VoiceHeaderRegTMComponent } from '../_pages/voice-header-registration-tm/voice-header-registration-tm.component';
import { VoiceHeaderModTMComponent } from '../_pages/voice-header-modification-tm/voice-header-modification-tm.component';
import { VoiceHeaderreglisttmComponent } from '../_pages/voice-header-reg-list-tm/voice-header-reg-list-tm.component';

//Voice Headers - PE
import { VoiceHeaderRegPEComponent } from '../_pages/voice-header-registration-pe/voice-header-registration-pe.component';
import { VoiceHeaderModPEComponent } from '../_pages/voice-header-modification-pe/voice-header-modification-pe.component';
import { VoiceHeaderreglistpeComponent } from '../_pages/voice-header-reg-list-pe/voice-header-reg-list-pe.component';

//Voice Templates - PE
import { VoiceTemplateRegDetailsBypeComponent } from '../_pages/voice-template-reg-details-by-pe/voice-template-reg-details-by-pe.component';
import { VoiceContentTemplateRegComponent } from '../_pages/voice-Template-reg-by-pe/voice-Template-reg-by-pe.component';
import { VoiceTemplateModificationbyPeComponent } from '../_pages/voice-template-modification-pe/voice-template-modification-pe.component';
import { VoiceTemplatesByPeComponent } from '../_pages/voice-templates-by-pe/voice-templates-by-pe.component';

//Voice Service Header
//PE Side
import { VoiceServiceHeaderRegPEComponent } from '../_pages/voice-service-header-registration-pe/voice-service-header-registration-pe.component';
import { VoiceServiceHeaderreglistpeComponent } from '../_pages/voice-service-header-reg-list-pe/voice-service-header-reg-list-pe.component';
import { VoiceServiceHeaderModificationPeComponent } from '../_pages/voice-service-header-modification-pe/voice-service-header-modification-pe.component';

//TM side
import { VoiceServiceHeaderreglisttmComponent } from '../_pages/voice-service-header-reg-list-tm/voice-service-header-reg-list-tm.component';
import { VoiceServiceHeaderRegTMComponent } from '../_pages/voice-service-header-registration-tm/voice-service-header-registration-tm.component';

//url Register

import { NgModule } from '@angular/core';
import { UrlRegisterListComponent } from '../_pages/url-register-list/url-register-list.component';
import { UrlRegistrationComponent } from '../_pages/url-registration/url-registration.component';

//pe side - petm binding
import { PETMBindingNewChainComponent } from '../_pages/petmbinding-new-chain-creation/petmbinding-new-chain-creation.component';
import {PETMBindingPEListComponent } from '../_pages/petmbinding-pelist/petmbinding-pelist.component';
//tm ta td side - petm binding
import {PETMBindingTMTATDListComponent} from '../_pages/petmbinding-tmtatdlist/petmbinding-tmtatdlist.component';
// utm registration - PEtm binding 
import {UTMCommonLoginComponent} from '../_pages/utm-common-login/utm-common-login.component';
// Entity kyc renewal payment pradnya
import { EntityKycRenewalProcessComponent } from '../_pages/entity-kyc-renewal-process/entity-kyc-renewal-process.component';

export const DashboardRouting: Routes = [

    {
        path: '', component: DashboardRootComponent, canActivateChild: [],
        children: [

            { path: '', component: HomeComponent, pathMatch: 'full' },
            { path: 'observer', component: HometspComponent, pathMatch: 'full' },
            { path: 'entity-registration', component: EntityRegistrationComponent, pathMatch: 'full' },

            { path: 'common-login', component: CommonLoginComponent, canActivateChild: [] },
            { path: 'entity-summary', component: EntitySummaryComponent },
            { path: 'preference-download', component: PrefrenceDownloadComponent },
            { path: 'preference-summary', component: PreferenceSummaryComponent },

            //{ path: 'import-preference', component: ImportPreferenceComponent  },

            { path: 'preference-ncpr-details', component: PreferenceNcprDetailsComponent },
            { path: 'invite-users', component: InviteUsersComponent },
            { path: 'restricted-words', component: BadWordsImportComponent },

            //{ path: 'forgot-password', component: ForgotPasswordComponent },


            { path: 'subscriber-login', component: SubscriberLoginComponent, canActivateChild: [] },
            { path: 'dnd-registration-details', component: DndRegistrationDetailsComponent },
            { path: 'search-dnd-preference', component: SearchDndPreferenceComponent },
            { path: 'complaints-download', component: ComplaintsDownloadComponent },
            { path: 'complaints-ncpr-summary', component: ComplaintsNcprSummaryComponent },
            { path: 'complaints-ncpr-details', component: ComplaintsNcprDetailsComponent },
            { path: 'complaints-summary', component: ComplaintsSummaryComponent },
            { path: 'entity-id-details', component: EntityIdDetailsComponent },


            { path: 'content-template-registration', component: ContentTemplateRegistrationComponent,canActivate: [AuthGuard] },
            { path: 'content-template-registration-action', component: ContentTemplateRegistrationActionComponent },
            { path: 'template-modification', component: TemplateModificationComponent },
            { path: 'templates-by-pe', component: TemplatesByPEComponent },
            { path: 'content-template-bulk-upload-summary', component: ContentTemplateBulkUploadSummaryComponent },
            { path: 'bulk-content-upload', component: BulkContentUploadComponent,canActivate: [AuthGuard] },


            { path: 'consent-new-registration', component: ConsentRegComponent,canActivate: [AuthGuard] },
            { path: 'entity-consent-template-report', component: EntityConsentReportComponent },
            { path: 'consent-template-bulk-upload-summary', component: ConsentTemplateBulkUploadSummaryComponent },
            { path: 'bulk-consent-template-registration', component: BulkConsentTemplateRegistrationComponent ,canActivate: [AuthGuard]},

            //Header 			 

            { path: 'principal-header-summary', component: PrincipalHeaderSummaryComponent },
            { path: 'header-voice', component: HeaderVoiceComponent },
            { path: 'header-voice-summary', component: HeaderVoiceSummaryComponent },


            { path: 'header-modify', component: HeaderModifyComponent },
            { path: 'headers-by-pe', component: HeadersByPeComponent },
            { path: 'new-header-registration', component: HeaderRegComponent,canActivate: [AuthGuard] },
            { path: 'import-header', component: ImportHeaderComponent ,canActivate: [AuthGuard]},
            { path: 'header-bulk-details', component: HeaderBulkDetailsComponent },
            // { path: 'header-auditlog', component: HeaderAuditLogComponent },   
            // { path: 'header-editlog', component:  HeaderEditLogComponent }, 
            { path: 'header-summary', component: HeaderSummaryComponent },
            { path: 'header-id-details', component: HeaderIdDetailsComponent },


            // Consent-Migration

            // { path: 'bulk-consent-upload', component: BulkConsentuploadComponent },
            { path: 'consent-reports', component: ConsentReportsComponent },
            { path: 'consent-bulk-upload-summary', component: ConsentBulkSummaryComponent },
            
            //Entity - PhaseI
            { path: 'change-password', component: ChangePasswordComponent },
            { path: 'forgot-password', component: ForgotPasswordComponent },
            { path: 'tmpe-common-registration-01', component: TMPECommonRegistrationComponent01 },
            { path: 'tmpe-common-registration-02', component: TMPECommonRegistrationComponent02 },
            { path: 'tmpe-modify-after-approval', component: TMPEModifyAfterApprovalComponent,canActivate: [AuthGuard] },
            { path: 'tmpe-modify-before-approval', component: TMPEModifyBeforeApprovalComponent },
            { path: 'tmpe-common-login', component: TmpeCommonLoginComponent, canActivateChild: [] },
            { path: 'entity-auditlog', component: EntityAuditLogComponent, canActivateChild: [] },
            { path: 'entity-editlog', component: EntityEditLogComponent },
            { path: 'entity-report', component: EntityReportComponent },
            { path: 'entity-verification', component: EntityVerificationComponent },
            { path: 'entity-worklist', component: EntityWorklistComponent },
            { path: 'tata-login', component: TataCommonLoginComponent, canActivateChild: [] },
            { path: 'tata-modification', component: TataEntityModificationComponent, pathMatch: 'full' },
            { path: 'tata-registration', component: TataEntityRegistrationComponent, pathMatch: 'full' },
            { path: 'modify-registrar', component: ModifyRegistrarComponent },
            { path: 'ttlusers-report', component: TtlusersReportComponent },
            { path: 'ttlusers-summary', component: TtlusersSummaryComponent },
            { path: 'tata-auditlog', component: TataAuditLogComponent }, 
            { path: 'complaint-registration-subscriber-02', component: ComplaintRegistrationSubscriberComponent },
            { path: 'complaint-registration-subscriber-01', component: ComplaintRegistrationSubscriber01Component },
            { path: 'dashboard', component: DashboardComponent, canActivateChild: [] },
            { path: 'entity-obv', component: EntityObvComponent, canActivateChild: [] },
            { path: 'header-obv', component: HeaderObvComponent, canActivateChild: [] },
			{ path: 'consent-obv', component: ConsentObvComponent, canActivateChild: [] },
            //Observer-Complaints
			{path: 'complaints-obv-dashboard-oap', component: ComplaintsObvDashboardOapComponent },
            { path: 'complaint-obv-comprehensive-rpt', component:ComplaintsObvComprehensiveRptComponent },
            { path: 'complaints-obv', component: ComplaintsObvComponent, canActivateChild: [] },
            { path: 'telemarketer-obv', component: TelemarketerObvComponent, canActivateChild: [] },
            { path: 'consent-template-obv', component: ConsentTemplateObvComponent, canActivateChild: [] },
            { path: 'content-template-obv', component: ContentTemplateObvComponent, canActivateChild: [] },
            { path: 'search-dnd-preference-obv', component: SearchDndPreferenceObvComponent, canActivateChild: [] },
            { path: 'operator-wise-count', component: OperatorWiseCountComponent, canActivateChild: [] },

            { path: 'ip-registration', component: IpRegistrationComponent,canActivate: [AuthGuard] },
            { path: 'payment-dues', component: PaymentDuesComponent, canActivateChild: [] },
            { path: 'payment-history', component: PaymentHistoryComponent, canActivateChild: [] },
            { path: 'payment-submit', component: PaymentSubmitComponent, canActivateChild: [] },
            { path: 'payment-receipt', component: PaymentreceiptComponent, canActivateChild: [] },

            { path: 'gst-registration', component: GstRegistrationComponent, canActivate: [AuthGuard] }, 
            { path: 'gstregistration-details', component: GstRegistrationDetailsComponent, canActivateChild: [] },
            { path: 'gstregistration-search', component: GstregistrationSearchComponent, canActivateChild: [] },

            { path: 'non-ttl-templates', component: NonTTLTemplatesComponent },
            { path: 'linking_consent', component: LinkingConsentComponent, canActivateChild: [] },

            { path: 'capture-request-onpe', component: CaptureRequestOnPEComponent,canActivate: [AuthGuard] },
            { path: 'request-status', component: RequestStatusComponent },

            { path: 'consent-acquisition', component: ConsentAcquisitionComponent,canActivate: [AuthGuard] },
            { path: 'consent-acquisition-qrcode', component: ConsentAcquisitionQRCodeComponent,canActivate: [AuthGuard] },
            { path: 'consent-status-summary', component: ConsentStatusSummaryComponent, canActivateChild: [] },
            { path: 'consent-acquisition-scanpg', component: ConsentAcquisitionScanPgComponent,canActivate: [AuthGuard] },
            { path: 'consentacqqr', component: ConsentAcqQrComponent, canActivateChild: [] },
            { path: 'digital-consentsummary', component: DigitalConsentsummaryComponent, canActivateChild: [] },
            { path: 'activate-digital-consent', component: ActivateDigitalConsentComponent, canActivateChild: [] },

            { path: 'templatecontentmodify', component: TemplatecontentmodifyComponent, canActivateChild: [] },
            { path: 'bulk-template-verification', component: BulkTemplateVerificationComponent, canActivateChild: [] },
            {path: 'bulk-template-verification-summary', component: BulkTemplateVerificationSummaryComponent, canActivateChild: [] },

            { path: 'header-suspension', component: HeaderSuspensionComponent },
            { path: 'extension-conversion-headers', component: ExtensionConversionHeadersComponent, canActivateChild: [] },

            { path: 'voice-header-registration-pe', component: VoiceHeaderRegPEComponent, canActivate: [AuthGuard] },
            { path: 'voice-header-modification-pe', component: VoiceHeaderModPEComponent },
            { path: 'voice-header-reg-list-pe', component: VoiceHeaderreglistpeComponent, canActivate: [AuthGuard]  },
			
			{ path: 'voice-header-registration-tm', component: VoiceHeaderRegTMComponent, canActivate: [AuthGuard]  },
            { path: 'voice-header-modification-tm', component: VoiceHeaderModTMComponent },      
            { path: 'voice-header-reg-list-tm', component: VoiceHeaderreglisttmComponent, canActivate: [AuthGuard]  },
			
			{ path: 'voice-Template-reg-by-pe', component: VoiceContentTemplateRegComponent, canActivate: [AuthGuard]  },
		    { path: 'voice-template-reg-details-by-pe', component: VoiceTemplateRegDetailsBypeComponent, canActivate: [AuthGuard]  },
            { path: 'voice-template-modification-pe', component: VoiceTemplateModificationbyPeComponent },
            { path: 'voice-templates-by-pe', component: VoiceTemplatesByPeComponent, canActivate: [AuthGuard]  },
            
            //Voice Service Header
            //PE Side
            { path: 'voice-service-header-registration-pe', component: VoiceServiceHeaderRegPEComponent, canActivateChild: [AuthGuard] },
            { path: 'voice-service-header-reg-list-pe', component: VoiceServiceHeaderreglistpeComponent },
            { path: 'voice-service-header-modification-pe', component: VoiceServiceHeaderModificationPeComponent, canActivateChild: [AuthGuard] },

            //TM Side
            { path: 'voice-service-header-list-tm', component: VoiceServiceHeaderreglisttmComponent },
            { path: 'voice-service-header-reg-tm', component: VoiceServiceHeaderRegTMComponent, canActivateChild: [AuthGuard] },

             //url-register
             { path: 'url-register-list', component: UrlRegisterListComponent, canActivate: [AuthGuard]  },
             { path: 'url-registration', component: UrlRegistrationComponent, canActivate: [AuthGuard]  },
             
            //pe side - petm binding
            { path: 'petmbinding-newchain-creation', component: PETMBindingNewChainComponent, canActivate: [AuthGuard]  },
            { path: 'petmbinding-pelist', component: PETMBindingPEListComponent, canActivate: [AuthGuard]},
            //utm side - petm binding
            { path: 'utm-common-login', component: UTMCommonLoginComponent },
            { path: 'petmbindinglist-tmtatdlist', component: PETMBindingTMTATDListComponent },

            // Entity KYC and renewal payment Pradnya
            { path: 'entity-kyc-renewal-payment', component: EntityKycRenewalProcessComponent, canActivateChild: [] },
        ]
    }
]

